module.exports = __webpack_public_path__ + "img/joinus.188ca6f5.png";